import { IBusinessType } from '@/models/business';

import store from '@/store';
import { appIsActive } from './appIsActive';

export function businessIsAllowedToSeeFeature(
  typeFeature: 'online' | 'physical'
) {
  const businessInfo = store.getters['business/getBusinessInfo'].business;

  if (
    !businessInfo ||
    (businessInfo.type === IBusinessType.INSTORE && typeFeature !== 'physical')
  ) {
    return false;
  }

  if (
    businessInfo.type === IBusinessType.ONLINE &&
    typeFeature === 'physical' &&
    !appIsActive()
  )
    return false;

  return true;
}
